import React from "react";
import { Dialog, DialogContent, TextField, Grid, DialogActions, Button, DialogTitle, Divider, } from "@material-ui/core";
import { SelectListField } from "../../../common/SelectListField";
import { usersService } from "../../../../services";
import { useFormState } from "../../../../hooks/useFormState";
import { useDispatch } from "react-redux";
import { submitAssignCaseLead, updateComplaint } from "../../../../redux/actions";
const MULTILINE_ROW_HEIGHT = 8;
const COMPLAINTS_TEAM_ID = "complaints";
export const CaseLeadDialog = ({ isDialogOpen, onDialogClose, caseId, }) => {
    const dispatch = useDispatch();
    const { formProps, triggerSubmit, triggerReset } = useFormState({
        noteBody: "",
        upn: "",
    }, ["upn"], ({ state }) => {
        dispatch(submitAssignCaseLead(caseId, state.values));
        dispatch(updateComplaint(caseId, [{ op: "replace", path: "/caseLead", value: state.values.upn }]));
        onDialogClose();
        triggerReset();
    });
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
            triggerReset();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "Assign case lead"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("upn"), { label: "Case Lead", dataTest: "case-lead-field", service: {
                                //TODO: get teamId from config
                                getAll: params => usersService.getAll(Object.assign(Object.assign({}, params), { teamId: COMPLAINTS_TEAM_ID })),
                            } }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("noteBody"), { label: "Note", "data-test": "case-lead-note-field", fullWidth: true, multiline: true, rows: MULTILINE_ROW_HEIGHT })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => triggerSubmit(), "data-test": "confirm-assign-button", color: "primary" }, "Assign case lead"))));
};
